export const contaPrimaraCourseData = {
  id: 3,

  title: 'Contabilitate primara',

  description:
    'Invata contabilitatea primara pas cu pas, de la documentele justificative pana la gestionarea completa a documentelor unei firme.',

  units: [
    /* =====================================================
       CAPITOLUL 1
    ===================================================== */

    {
      id: 1,

      title: 'Introducere in contabilitatea primara',

      description:
        'Intelege rolul contabilitatii primare, documentele justificative si circuitul acestora intr-o firma.',

      lessons: [
        {
          id: 1,
          code: '1.1',
          title: 'Ce este contabilitatea primara',
          type: 'lesson',
        },
        {
          id: 2,
          code: '1.2',
          title: 'Rolul contabilitatii primare intr-o firma',
          type: 'lesson',
        },
        {
          id: 3,
          code: '1.3',
          title: 'Operatiunile economico-financiare',
          type: 'lesson',
        },
        {
          id: 4,
          code: '1.4',
          title: 'Documentele justificative',
          type: 'lesson',
        },
        {
          id: 5,
          code: '1.5',
          title: 'Elementele obligatorii ale documentelor justificative',
          type: 'lesson',
        },
        {
          id: 6,
          code: '1.6',
          title: 'Circuitul documentelor intr-o firma',
          type: 'lesson',
        },
        {
          id: 7,
          code: '1.7',
          title: 'Intocmirea, verificarea si corectarea documentelor',
          type: 'lesson',
        },
        {
          id: 8,
          code: '1.8',
          title: 'Organizarea si pastrarea documentelor financiar-contabile',
          type: 'lesson',
        },
      ],
    },


    /* =====================================================
       CAPITOLUL 2
    ===================================================== */

    {
      id: 2,

      title: 'Factura',

      description:
        'Invata cum se intocmeste, verifica, corecteaza si urmareste o factura in activitatea unei firme.',

      lessons: [
        {
          id: 1,
          code: '2.1',
          title: 'Ce este factura si cand se utilizeaza',
          type: 'lesson',
        },
        {
          id: 2,
          code: '2.2',
          title: 'Elementele unei facturi',
          type: 'lesson',
        },
        {
          id: 3,
          code: '2.3',
          title: 'Factura de vanzare',
          type: 'lesson',
        },
        {
          id: 4,
          code: '2.4',
          title: 'Factura de achizitie',
          type: 'lesson',
        },
        {
          id: 5,
          code: '2.5',
          title: 'Facturarea bunurilor si serviciilor',
          type: 'lesson',
        },
        {
          id: 6,
          code: '2.6',
          title: 'TVA si informatiile fiscale de pe factura',
          type: 'lesson',
        },
        {
          id: 7,
          code: '2.7',
          title: 'Factura de avans',
          type: 'lesson',
        },
        {
          id: 8,
          code: '2.8',
          title: 'Reducerile comerciale pe factura',
          type: 'lesson',
        },
        {
          id: 9,
          code: '2.9',
          title: 'Corectarea si anularea facturilor',
          type: 'lesson',
        },
        {
          id: 10,
          code: '2.10',
          title: 'Verificarea unei facturi primite',
          type: 'lesson',
        },
        {
          id: 11,
          code: '2.11',
          title: 'Scadenta si urmarirea facturilor',
          type: 'lesson',
        },
        {
          id: 12,
          code: '2.12',
          title: 'Intocmirea practica a unei facturi',
          type: 'lesson',
        },
        {
          id: 13,
          title: 'Intocmeste si verifica o factura',
          type: 'practice',
        },
      ],
    },


    /* =====================================================
       CAPITOLUL 3
    ===================================================== */

    {
      id: 3,

      title: 'RO e-Factura',

      description:
        'Invata circuitul unei facturi electronice, de la emitere si transmitere pana la primire si verificare.',

      lessons: [
        {
          id: 1,
          code: '3.1',
          title: 'Ce este sistemul RO e-Factura',
          type: 'lesson',
        },
        {
          id: 2,
          code: '3.2',
          title: 'Cine utilizeaza RO e-Factura',
          type: 'lesson',
        },
        {
          id: 3,
          code: '3.3',
          title: 'Emiterea unei facturi electronice',
          type: 'lesson',
        },
        {
          id: 4,
          code: '3.4',
          title: 'Transmiterea facturii in sistem',
          type: 'lesson',
        },
        {
          id: 5,
          code: '3.5',
          title: 'Primirea facturilor electronice',
          type: 'lesson',
        },
        {
          id: 6,
          code: '3.6',
          title: 'Verificarea unei facturi din RO e-Factura',
          type: 'lesson',
        },
        {
          id: 7,
          code: '3.7',
          title: 'Corectarea facturilor electronice',
          type: 'lesson',
        },
        {
          id: 8,
          code: '3.8',
          title: 'Circuitul complet al unei e-Facturi',
          type: 'lesson',
        },
        {
          id: 9,
          title: 'Proceseaza o factura electronica',
          type: 'practice',
        },
      ],
    },


    /* =====================================================
       CAPITOLUL 4
    ===================================================== */

    {
      id: 4,

      title: 'Incasarile si platile in numerar',

      description:
        'Invata documentele si regulile utilizate pentru incasarile si platile efectuate in numerar.',

      lessons: [
        {
          id: 1,
          code: '4.1',
          title: 'Operatiunile cu numerar',
          type: 'lesson',
        },
        {
          id: 2,
          code: '4.2',
          title: 'Documentele utilizate pentru operatiunile in numerar',
          type: 'lesson',
        },
        {
          id: 3,
          code: '4.3',
          title: 'Chitanta',
          type: 'lesson',
        },
        {
          id: 4,
          code: '4.4',
          title: 'Elementele obligatorii ale chitantei',
          type: 'lesson',
        },
        {
          id: 5,
          code: '4.5',
          title: 'Intocmirea unei chitante',
          type: 'lesson',
        },
        {
          id: 6,
          code: '4.6',
          title: 'Dispozitia de plata/incasare catre casierie',
          type: 'lesson',
        },
        {
          id: 7,
          code: '4.7',
          title: 'Limitele operatiunilor cu numerar',
          type: 'lesson',
        },
        {
          id: 8,
          code: '4.8',
          title: 'Verificarea documentelor de incasare si plata',
          type: 'lesson',
        },
        {
          id: 9,
          title:
            'Intocmeste o chitanta si documenteaza o operatiune in numerar',
          type: 'practice',
        },
      ],
    },


    /* =====================================================
       CAPITOLUL 5
    ===================================================== */

    {
      id: 5,

      title: 'Registrul de casa',

      description:
        'Invata cum se construieste si verifica registrul de casa pe baza incasarilor si platilor unei zile.',

      lessons: [
        {
          id: 1,
          code: '5.1',
          title: 'Ce este registrul de casa',
          type: 'lesson',
        },
        {
          id: 2,
          code: '5.2',
          title: 'Documentele care stau la baza registrului de casa',
          type: 'lesson',
        },
        {
          id: 3,
          code: '5.3',
          title: 'Soldul initial al casei',
          type: 'lesson',
        },
        {
          id: 4,
          code: '5.4',
          title: 'Inregistrarea incasarilor',
          type: 'lesson',
        },
        {
          id: 5,
          code: '5.5',
          title: 'Inregistrarea platilor',
          type: 'lesson',
        },
        {
          id: 6,
          code: '5.6',
          title: 'Stabilirea soldului final',
          type: 'lesson',
        },
        {
          id: 7,
          code: '5.7',
          title: 'Verificarea registrului de casa',
          type: 'lesson',
        },
        {
          id: 8,
          code: '5.8',
          title: 'Erori intalnite in registrul de casa',
          type: 'lesson',
        },
        {
          id: 9,
          title: 'Intocmeste registrul de casa pentru o zi',
          type: 'practice',
        },
      ],
    },


    /* =====================================================
       CAPITOLUL 6
    ===================================================== */

    {
      id: 6,

      title: 'Operatiunile prin banca',

      description:
        'Invata sa verifici incasarile si platile bancare si sa le asociezi documentelor corespunzatoare.',

      lessons: [
        {
          id: 1,
          code: '6.1',
          title: 'Incasarile si platile prin banca',
          type: 'lesson',
        },
        {
          id: 2,
          code: '6.2',
          title: 'Ordinul de plata',
          type: 'lesson',
        },
        {
          id: 3,
          code: '6.3',
          title: 'Extrasul de cont bancar',
          type: 'lesson',
        },
        {
          id: 4,
          code: '6.4',
          title: 'Identificarea tranzactiilor din extras',
          type: 'lesson',
        },
        {
          id: 5,
          code: '6.5',
          title: 'Asocierea unei plati cu factura corespunzatoare',
          type: 'lesson',
        },
        {
          id: 6,
          code: '6.6',
          title: 'Asocierea unei incasari cu factura emisa',
          type: 'lesson',
        },
        {
          id: 7,
          code: '6.7',
          title: 'Urmarirea facturilor incasate si neachitate',
          type: 'lesson',
        },
        {
          id: 8,
          code: '6.8',
          title: 'Verificarea operatiunilor bancare',
          type: 'lesson',
        },
        {
          id: 9,
          title: 'Potriveste facturile cu tranzactiile bancare',
          type: 'practice',
        },
      ],
    },


    /* =====================================================
       CAPITOLUL 7
    ===================================================== */

    {
      id: 7,

      title: 'Achizitia si receptia bunurilor',

      description:
        'Urmeaza circuitul complet al unei achizitii, de la factura furnizorului pana la receptia bunurilor.',

      lessons: [
        {
          id: 1,
          code: '7.1',
          title: 'Circuitul documentelor unei achizitii',
          type: 'lesson',
        },
        {
          id: 2,
          code: '7.2',
          title: 'Factura de achizitie',
          type: 'lesson',
        },
        {
          id: 3,
          code: '7.3',
          title: 'Avizul de insotire a marfii',
          type: 'lesson',
        },
        {
          id: 4,
          code: '7.4',
          title: 'Receptia bunurilor',
          type: 'lesson',
        },
        {
          id: 5,
          code: '7.5',
          title: 'Nota de receptie si constatare de diferente (NIR)',
          type: 'lesson',
        },
        {
          id: 6,
          code: '7.6',
          title: 'Cand se intocmeste NIR-ul',
          type: 'lesson',
        },
        {
          id: 7,
          code: '7.7',
          title: 'Completarea unui NIR',
          type: 'lesson',
        },
        {
          id: 8,
          code: '7.8',
          title: 'Diferentele constatate la receptie',
          type: 'lesson',
        },
        {
          id: 9,
          code: '7.9',
          title: 'Returul bunurilor catre furnizor',
          type: 'lesson',
        },
        {
          id: 10,
          code: '7.10',
          title: 'Verificarea documentelor unei achizitii',
          type: 'lesson',
        },
        {
          id: 11,
          title:
            'Receptioneaza o comanda si intocmeste documentele necesare',
          type: 'practice',
        },
      ],
    },


    /* =====================================================
       CAPITOLUL 8
    ===================================================== */

    {
      id: 8,

      title: 'Gestiunea stocurilor',

      description:
        'Invata documentele si operatiunile utilizate pentru evidenta intrarilor si iesirilor din gestiune.',

      lessons: [
        {
          id: 1,
          code: '8.1',
          title: 'Ce reprezinta gestiunea stocurilor',
          type: 'lesson',
        },
        {
          id: 2,
          code: '8.2',
          title: 'Intrarile in gestiune',
          type: 'lesson',
        },
        {
          id: 3,
          code: '8.3',
          title: 'Iesirile din gestiune',
          type: 'lesson',
        },
        {
          id: 4,
          code: '8.4',
          title: 'Fisa de magazie',
          type: 'lesson',
        },
        {
          id: 5,
          code: '8.5',
          title: 'Bonul de consum',
          type: 'lesson',
        },
        {
          id: 6,
          code: '8.6',
          title: 'Bonul de predare, transfer si restituire',
          type: 'lesson',
        },
        {
          id: 7,
          code: '8.7',
          title: 'Transferul bunurilor intre gestiuni',
          type: 'lesson',
        },
        {
          id: 8,
          code: '8.8',
          title: 'Evidenta cantitativa a stocurilor',
          type: 'lesson',
        },
        {
          id: 9,
          code: '8.9',
          title: 'Verificarea stocului scriptic si faptic',
          type: 'lesson',
        },
        {
          id: 10,
          title: 'Gestioneaza intrarile si iesirile dintr-o magazie',
          type: 'practice',
        },
      ],
    },


    /* =====================================================
       CAPITOLUL 9
    ===================================================== */

    {
      id: 9,

      title: 'Deconturile si cheltuielile angajatilor',

      description:
        'Invata cum se acorda, justifica si verifica avansurile si cheltuielile efectuate de angajati.',

      lessons: [
        {
          id: 1,
          code: '9.1',
          title: 'Ce este avansul spre decontare',
          type: 'lesson',
        },
        {
          id: 2,
          code: '9.2',
          title: 'Acordarea unui avans',
          type: 'lesson',
        },
        {
          id: 3,
          code: '9.3',
          title: 'Documentele justificative ale cheltuielilor',
          type: 'lesson',
        },
        {
          id: 4,
          code: '9.4',
          title: 'Bonurile fiscale',
          type: 'lesson',
        },
        {
          id: 5,
          code: '9.5',
          title: 'Decontul de cheltuieli',
          type: 'lesson',
        },
        {
          id: 6,
          code: '9.6',
          title: 'Deplasarile in interes de serviciu',
          type: 'lesson',
        },
        {
          id: 7,
          code: '9.7',
          title: 'Restituirea sumelor neutilizate',
          type: 'lesson',
        },
        {
          id: 8,
          code: '9.8',
          title: 'Sumele suplimentare datorate angajatului',
          type: 'lesson',
        },
        {
          id: 9,
          code: '9.9',
          title: 'Verificarea unui decont',
          type: 'lesson',
        },
        {
          id: 10,
          title:
            'Primesti un avans si justifici cheltuielile unei deplasari',
          type: 'practice',
        },
      ],
    },


    /* =====================================================
       CAPITOLUL 10
    ===================================================== */

    {
      id: 10,

      title: 'Imobilizarile si obiectele de inventar',

      description:
        'Invata documentele si operatiunile necesare pentru evidenta bunurilor utilizate pe termen lung.',

      lessons: [
        {
          id: 1,
          code: '10.1',
          title: 'Bunurile utilizate pe termen lung in firma',
          type: 'lesson',
        },
        {
          id: 2,
          code: '10.2',
          title:
            'Diferenta dintre stocuri, obiecte de inventar si imobilizari',
          type: 'lesson',
        },
        {
          id: 3,
          code: '10.3',
          title: 'Documentele aferente achizitiei unui bun',
          type: 'lesson',
        },
        {
          id: 4,
          code: '10.4',
          title: 'Receptia bunurilor',
          type: 'lesson',
        },
        {
          id: 5,
          code: '10.5',
          title: 'Punerea in functiune',
          type: 'lesson',
        },
        {
          id: 6,
          code: '10.6',
          title: 'Evidenta documentara a imobilizarilor',
          type: 'lesson',
        },
        {
          id: 7,
          code: '10.7',
          title: 'Evidenta obiectelor de inventar',
          type: 'lesson',
        },
        {
          id: 8,
          code: '10.8',
          title: 'Transferul si scoaterea din evidenta a bunurilor',
          type: 'lesson',
        },
        {
          id: 9,
          title:
            'Firma cumpara un laptop - proceseaza documentele',
          type: 'practice',
        },
      ],
    },


    /* =====================================================
       CAPITOLUL 11
    ===================================================== */

    {
      id: 11,

      title: 'Inventarierea',

      description:
        'Invata etapele inventarierii si modul in care se identifica si documenteaza diferentele de inventar.',

      lessons: [
        {
          id: 1,
          code: '11.1',
          title: 'Ce este inventarierea',
          type: 'lesson',
        },
        {
          id: 2,
          code: '11.2',
          title: 'De ce si cand se realizeaza inventarierea',
          type: 'lesson',
        },
        {
          id: 3,
          code: '11.3',
          title: 'Pregatirea inventarierii',
          type: 'lesson',
        },
        {
          id: 4,
          code: '11.4',
          title: 'Inventarierea faptica',
          type: 'lesson',
        },
        {
          id: 5,
          code: '11.5',
          title: 'Lista de inventariere',
          type: 'lesson',
        },
        {
          id: 6,
          code: '11.6',
          title: 'Compararea stocului faptic cu cel scriptic',
          type: 'lesson',
        },
        {
          id: 7,
          code: '11.7',
          title: 'Plusurile de inventar',
          type: 'lesson',
        },
        {
          id: 8,
          code: '11.8',
          title: 'Lipsurile de inventar',
          type: 'lesson',
        },
        {
          id: 9,
          code: '11.9',
          title: 'Documentele rezultate in urma inventarierii',
          type: 'lesson',
        },
        {
          id: 10,
          title: 'Realizeaza inventarierea unei gestiuni',
          type: 'practice',
        },
      ],
    },


    /* =====================================================
       CAPITOLUL 12
    ===================================================== */

    {
      id: 12,

      title: 'Organizarea documentelor financiar-contabile',

      description:
        'Invata cum se verifica, clasifica, organizeaza si pregatesc documentele firmei pentru contabil.',

      lessons: [
        {
          id: 1,
          code: '12.1',
          title: 'Primirea documentelor de la furnizori si angajati',
          type: 'lesson',
        },
        {
          id: 2,
          code: '12.2',
          title: 'Verificarea documentelor',
          type: 'lesson',
        },
        {
          id: 3,
          code: '12.3',
          title: 'Identificarea documentelor lipsa',
          type: 'lesson',
        },
        {
          id: 4,
          code: '12.4',
          title: 'Clasificarea documentelor',
          type: 'lesson',
        },
        {
          id: 5,
          code: '12.5',
          title: 'Organizarea facturilor de achizitie',
          type: 'lesson',
        },
        {
          id: 6,
          code: '12.6',
          title: 'Organizarea facturilor de vanzare',
          type: 'lesson',
        },
        {
          id: 7,
          code: '12.7',
          title: 'Organizarea documentelor de casa si banca',
          type: 'lesson',
        },
        {
          id: 8,
          code: '12.8',
          title: 'Organizarea documentelor de gestiune',
          type: 'lesson',
        },
        {
          id: 9,
          code: '12.9',
          title: 'Arhivarea documentelor',
          type: 'lesson',
        },
        {
          id: 10,
          code: '12.10',
          title: 'Pregatirea documentelor pentru contabil',
          type: 'lesson',
        },
        {
          id: 11,
          title: 'Pregateste documentele lunii pentru contabil',
          type: 'practice',
        },
      ],
    },


    /* =====================================================
       CAPITOLUL 13
       SIMULARE FINALA
    ===================================================== */

    {
      id: 13,

      title: 'Simulare finala: O luna de contabilitate primara',

      description:
        'Aplica intr-un scenariu complet cunostintele acumulate pe parcursul cursului.',

      type: 'final-simulation',

      lessons: [
        {
          id: 1,
          code: 'M1',
          title: 'Primesti si verifici documentele firmei',
          type: 'mission',
        },
        {
          id: 2,
          code: 'M2',
          title: 'Intocmesti o factura de vanzare',
          type: 'mission',
        },
        {
          id: 3,
          code: 'M3',
          title: 'Inregistrezi incasarea si intocmesti chitanta',
          type: 'mission',
        },
        {
          id: 4,
          code: 'M4',
          title: 'Procesezi o achizitie de marfa',
          type: 'mission',
        },
        {
          id: 5,
          code: 'M5',
          title: 'Receptionezi bunurile si completezi NIR-ul',
          type: 'mission',
        },
        {
          id: 6,
          code: 'M6',
          title: 'Gestionezi consumul/iesirea unor bunuri',
          type: 'mission',
        },
        {
          id: 7,
          code: 'M7',
          title: 'Procesezi operatiunile prin banca',
          type: 'mission',
        },
        {
          id: 8,
          code: 'M8',
          title: 'Intocmesti registrul de casa',
          type: 'mission',
        },
        {
          id: 9,
          code: 'M9',
          title: 'Verifici decontul unui angajat',
          type: 'mission',
        },
        {
          id: 10,
          code: 'M10',
          title: 'Procesezi achizitia unui echipament',
          type: 'mission',
        },
        {
          id: 11,
          code: 'M11',
          title: 'Identifici documentele gresite sau lipsa',
          type: 'mission',
        },
        {
          id: 12,
          code: 'M12',
          title: 'Pregatesti dosarul lunii pentru contabil',
          type: 'mission',
        },
        {
          id: 13,
          title:
            'Gestioneaza contabilitatea primara a NOVA SRL pentru o luna',
          type: 'project',
        },
      ],
    },
  ],
};

export default contaPrimaraCourseData;